import { TABLE_LENGTH_M, TABLE_WIDTH_M } from "../../utils/tableUv";
import { useTranslation } from "react-i18next";

const COLOR_SHORT = "#4FC3F7";
const COLOR_LONG = "#FFB74D";
const COLOR_MISSED = "#EF5350";

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function lengthColor(length) {
  if (length === "short") return COLOR_SHORT;
  if (length === "long") return COLOR_LONG;
  return COLOR_MISSED;
}

const VB = {
  w: TABLE_LENGTH_M * 100,
  h: TABLE_WIDTH_M * 100,
};

/**
 * Top-down table heat of serve landings (P2 / P3 in table UV).
 */
export function ServeBounceHeatMap({
  points = [],
  metrics = null,
  ariaLabel = "Serve bounce heat map",
}) {
  const { t } = useTranslation();
  const list = Array.isArray(points) ? points : [];
  const tries = num(metrics?.serve_try_count) ?? list.length;
  const short = num(metrics?.serve_short_count);
  const long = num(metrics?.serve_long_count);
  const missed = num(metrics?.serve_missed_count);

  return (
    <figure className="serve-bounce-heatmap" aria-label={ariaLabel}>
      <svg
        viewBox={`0 0 ${VB.w} ${VB.h}`}
        role="img"
        aria-hidden="true"
        className="serve-bounce-heatmap__svg"
      >
        <rect x="0" y="0" width={VB.w} height={VB.h} fill="#0f766e" rx="4" />
        <line
          x1={VB.w / 2}
          y1="0"
          x2={VB.w / 2}
          y2={VB.h}
          stroke="rgba(255,255,255,0.85)"
          strokeWidth="2"
        />
        {list.map((p, i) => {
          const u = num(p.u);
          const v = num(p.v);
          if (u == null || v == null) return null;
          const cx = Math.max(0, Math.min(1, u)) * VB.w;
          const cy = Math.max(0, Math.min(1, v)) * VB.h;
          return (
            <circle
              key={`${p.t_ms || i}-${p.n || 0}`}
              cx={cx}
              cy={cy}
              r={p.n === 3 ? 5 : 7}
              fill={lengthColor(p.length)}
              stroke="rgba(0,0,0,0.45)"
              strokeWidth="1"
            />
          );
        })}
      </svg>
      <figcaption className="serve-bounce-heatmap__caption">
        {tries != null ? `${tries} ${t("attempts", "Attempts").toLowerCase()}` : null}
        {short != null ? ` · ${short} short` : null}
        {long != null ? ` · ${long} long` : null}
        {missed != null ? ` · ${missed} missed` : null}
      </figcaption>
    </figure>
  );
}

export default ServeBounceHeatMap;
